<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-align-vertically`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M8.00076 1.16956C8.45881 1.16982 8.83064 1.54157 8.83084 1.99963V3.16956H10.8513C11.3094 3.16992 11.6814 3.54149 11.6814 3.99963C11.6814 4.45781 11.3094 4.82935 10.8513 4.82971H8.83084V7.16956H13.0779C13.536 7.16989 13.908 7.54147 13.908 7.99963C13.908 8.45783 13.536 8.82938 13.0779 8.82971H8.82986V11.1696H11.8045C12.2628 11.1696 12.6345 11.5413 12.6346 11.9996C12.6346 12.458 12.2629 12.8297 11.8045 12.8297H8.82986V13.9996C8.82986 14.458 8.45818 14.8297 7.99979 14.8297C7.54161 14.8294 7.16971 14.4579 7.16971 13.9996V12.8297H4.1951C3.73693 12.8294 3.36502 12.4579 3.36502 11.9996C3.36505 11.5414 3.73695 11.1698 4.1951 11.1696H7.16971V8.82971H2.92361C2.46522 8.82971 2.09354 8.45803 2.09354 7.99963C2.09357 7.54127 2.46524 7.16956 2.92361 7.16956H7.17068V4.82971H5.15018C4.69178 4.82971 4.3201 4.45803 4.3201 3.99963C4.32013 3.54127 4.6918 3.16956 5.15018 3.16956H7.17068V1.99963C7.17088 1.54141 7.54249 1.16956 8.00076 1.16956Z"/></svg>
</template>
<script>

export default {
  name: 'IconLineAlignVertically',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
